import { areaSeriesMark } from "../area/constant";

export const rangeAreaSeriesMark = Object.assign({}, areaSeriesMark);
//# sourceMappingURL=constant.js.map
